import { environment } from '@environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';

import { AuthService } from '@views/misc/auth/auth.service';

import { StorageService } from '../auth/storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  private storageService = inject(StorageService);

  resendConfirmEmail(): Observable<Record<string, unknown>> {
    const userId = this.storageService.getUserId();
    if (!userId) return EMPTY;
    return this.http.post<Record<string, unknown>>(
      `${environment.endpointApiOne}/v1/users/${userId}/resend-confirm-email`,
      {},
      {
        headers: this.authService.createAuthHeaders(),
      },
    );
  }
}
